export const selectFormState =(state: { form: any }) => state.form;